import { BaseEntity } from '../base/BaseEntity'
import { Field, ObjectType } from 'type-graphql'
import { modelOptions, Prop } from '@typegoose/typegoose'
import { BoardItem } from './BoardItem'

@ObjectType()
@modelOptions({ schemaOptions: { timestamps: true } })
export class Board extends BaseEntity {
  @Field(() => String)
  @Prop({ type: [String] })
  users?: string[]

  @Field(() => [BoardItem])
  @Prop({ type: [BoardItem] })
  items: BoardItem[]

  @Field(() => String)
  @Prop({ type: String })
  icon: string
}
